module.exports = __webpack_public_path__ + "img/crunch.49c75490.jpeg";